import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Panel",
  "use": "Panel-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Panel\">\r\n<path d=\"M0 3.5C0 2.39543 0.895431 1.5 2 1.5H14C15.1046 1.5 16 2.39543 16 3.5V13.5C16 14.6046 15.1046 15.5 14 15.5H2C0.895431 15.5 0 14.6046 0 13.5V3.5ZM5 2.5V14.5H14C14.5523 14.5 15 14.0523 15 13.5V3.5C15 2.94772 14.5523 2.5 14 2.5H5ZM4 2.5H2C1.44772 2.5 1 2.94772 1 3.5V13.5C1 14.0523 1.44772 14.5 2 14.5H4V2.5Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol